import { ProductType } from './../../../client';
import {
    ProductDetailValue,
    ProductDetailVariantValue,
    ProductSetDetailValue,
    ProductStandardDetailValue,
} from './../../../server';

// TODO : locally created but this type will be created with Quick View use case
type LoyaltyBenefitsValue = {
    earnedPoints?: number;
};

type ProductSetId = Pick<ProductSetDetailValue, 'productSetId'>;

type ProductStandardIds = Pick<ProductStandardDetailValue, 'masterId' | 'sku'>;

type BaseInformationValue = Pick<
    ProductDetailValue,
    | 'name'
    | 'description'
    | 'rating'
    | 'reviewCount'
    | 'price'
    | 'priorPrice'
    | 'originalPrice'
    | 'pricePerUnit'
    | 'totalIndividualPrice'
    | 'priceAlwaysBlack'
    | 'currency'
    | 'discountPercentage'
    | 'promotion'
    | 'enableDiscountInfo'
    | 'stockLevel'
    | 'medias'
    | 'isRedDot'
    | 'type'
> & {
    variants?: ProductDetailVariantValue[];
    loyaltyBenefits?: LoyaltyBenefitsValue;
};

export type ProductDetailInformationValue = BaseInformationValue &
    (
        | ({
              type: ProductType.PRODUCT_SET;
          } & ProductSetId)
        | ({
              type: Exclude<ProductType, ProductType.PRODUCT_SET>;
          } & ProductStandardIds)
    );

export const isProductSet = (productDetail: ProductDetailInformationValue): productDetail is ProductSetDetailValue => {
    return productDetail.type === ProductType.PRODUCT_SET;
};

export const mapProductDetailInformationValue = (productDetail: ProductDetailValue): ProductDetailInformationValue => {
    const productDetailInformationValue = {
        name: productDetail.name,
        rating: productDetail.rating,
        reviewCount: productDetail.reviewCount,
        description: productDetail.description,
        price: productDetail.price,
        priorPrice: productDetail.priorPrice,
        originalPrice: productDetail.originalPrice,
        pricePerUnit: productDetail.pricePerUnit,
        totalIndividualPrice: productDetail.totalIndividualPrice,
        priceAlwaysBlack: productDetail.priceAlwaysBlack,
        currency: productDetail.currency,
        discountPercentage: productDetail.discountPercentage,
        promotion: productDetail.promotion,
        enableDiscountInfo: productDetail.enableDiscountInfo,
        stockLevel: productDetail.stockLevel,
        isRedDot: productDetail.isRedDot,
        medias: productDetail.medias,
        loyaltyBenefits: undefined,
    };

    if (isProductSet(productDetail)) {
        return { ...productDetailInformationValue, type: productDetail.type, productSetId: productDetail.productSetId };
    }

    return {
        ...productDetailInformationValue,
        type: productDetail.type,
        masterId: productDetail.masterId,
        sku: productDetail.sku,
        variants: productDetail.variants,
    };
};
